import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { Asset } from '../sidebar';

export interface LiveVideoRoomState {
  hlsVideoURL: string;
  fillerSlideURL: string;
  isFillerSlideVisible: Boolean;
  hlsVideoElm: any | null;
  currentPlayingVideoAsset: Asset | null;
  hlsContext?: any | null;
  rtmpHlsContext?: any | null;
  totalDurationOfPlayingVideo: number;
  startTimeOfVideoPlayback: Date | null;
  currentPlaybackDuration: number;
  isWaitingForVideoLoadToStart: Boolean;
  idOfSelectedVideo: string;
  isSwitchingToSpeakerMode: Boolean;
  hasErrorWhenSwitchingToSpeakerMode: Boolean;
  hasVideoBufferPlaybackStalled: Boolean;
  timeOutToHandlePlaybackStall: null | ReturnType<typeof setTimeout>;
  timeToWaitBeforeShowingLoading: number;
  timeoutToHanldeManifiestLoadErrors: null | ReturnType<typeof setTimeout>;
  timeToWaitBeforeRetryingLevelLoad: number;
  hlsFragmentsThatFailedToLoad: Array<any>;
  playbackStartTimeOverride: number | null;
  intervalForVideoPlaybackSync: null | ReturnType<typeof setInterval>;
  isHLSStreamingSupported: boolean;
  retriesDoneForLevelLoadingError: number;
  retriesDoneForFragLoadingError: number;
  retriesDoneForManifestLoadingError: number;
  liveVideoRoomVideoPlaybackStartState: 'IDLE' | 'LOADING' | 'SUCCESS' | 'ERROR';
  videoPlaybackStartStateTimeout: null | ReturnType<typeof setTimeout>;
  isHLSLevelLoadError: Boolean;
  isHLSManifestLoadError: Boolean;
  isHLSFragLoadError: Boolean;
}

const state: LiveVideoRoomState = {
  fillerSlideURL: '',
  hlsVideoURL: '',
  isFillerSlideVisible: true,
  hlsVideoElm: document.createElement('video'),
  currentPlayingVideoAsset: null,
  // hlsContext: null,
  totalDurationOfPlayingVideo: 0,
  startTimeOfVideoPlayback: null,
  currentPlaybackDuration: -1,
  isWaitingForVideoLoadToStart: false,
  idOfSelectedVideo: '',
  isSwitchingToSpeakerMode: false,
  hasErrorWhenSwitchingToSpeakerMode: false,
  hasVideoBufferPlaybackStalled: false,
  timeOutToHandlePlaybackStall: null,
  timeToWaitBeforeShowingLoading: 2000,
  timeoutToHanldeManifiestLoadErrors: null,
  timeToWaitBeforeRetryingLevelLoad: 8000,
  hlsFragmentsThatFailedToLoad: [],
  playbackStartTimeOverride: null,
  intervalForVideoPlaybackSync: null,
  isHLSStreamingSupported: true,
  retriesDoneForLevelLoadingError: 0,
  retriesDoneForFragLoadingError: 0,
  retriesDoneForManifestLoadingError: 0,
  liveVideoRoomVideoPlaybackStartState: 'IDLE',
  videoPlaybackStartStateTimeout: null,
  isHLSLevelLoadError: false,
  isHLSManifestLoadError: false,
  isHLSFragLoadError: false
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
